<template>
	<div class="">
		<Header></Header>
		<div class="Qm_detail">
			<div class="Qm_title">
				<p>面试时提问，你为什么选择教师这个岗位，应该怎么回答你为什么选择教师这个岗位</p>
			</div>
			<div class="Qm_info">
				<p>
					<span>
						<img src="../assets/dow/pdf.png" alt="" width="16px" height="16px">
					</span>
					<span>小王</span>
					<span>2019-1-21</span>

				</p>
				<p @click="userAnwiser">我要回答</p>
			</div>
		</div>
		<div class="anwsernum">
			<p>360回答</p>
		</div>
		<div class="anwiserList">
			<ul>
				<li>
					<div class="alL">
						<img src="../assets/dow/xl.png" alt="" width="20px" height="20px">
					</div>
					<div class="alR">
						<p><span>张同学</span><span>2019-11-19 22:34</span></p>
						<p>我读的就是师范类的专业，做教师符合自己的专业，而且现在公司之类工作不够稳定，教师定。</p>
					</div>
				</li>
				<li>
					<div class="alL">
						<img src="../assets/home/scholl.jpg" alt="" width="20px" height="20px">
					</div>
					<div class="alR">
						<p><span>张同学</span><span>2019-11-19 22:34</span></p>
						<p>我读的就是师范类的专业，做教师符合自己的专业，</p>
					</div>
				</li>
				
			</ul>
		</div>
		<Fotter></Fotter>
		<div class="questionBtn">
			<p @click="myqueston">我要回答</p>
		</div>
		<van-dialog
		  v-model="show"
		  title="回答"
		  confirm-button-text='回答'
		  @confirm='sussessques'
		  @cancel='hidebox'
		  :close-on-click-overlay=true   
		  show-cancel-button
		>
		<van-field
			  v-model="message"
			  rows="1"
			  autosize
			  type="textarea"
			  placeholder="请输入回复内容"
			/>
		  
		</van-dialog>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Quesrionmore_detail',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
               show:false,
			   message:''
			}

		},
		methods: {
          userAnwiser(){
			 this.show=true;
		  },
			myqueston(){
				this.show=true;
			},
			 //确定
			sussessques(){
				 this.message='';
			},
			//q取消
			hidebox(){
				this.message='';
			},

		}
	}
</script>

<style scoped>
	.Qm_detail {
		width: 95%;

		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
		border-radius: 7px;
		margin: 20px auto;
	}

	.Qm_title p {
		padding: 13px;
		font-size: 14px;
		font-weight: bold;
		line-height: 20 px;
		color: #333;
	}

	.Qm_info {
		padding: 13px;
		display: flex;
	}

	.Qm_info p:nth-child(1) {
		flex: 1;
		display: flex;
	}

	.Qm_info p:nth-child(1) span:nth-child(1) {
		margin-left: 0px;
	}

	.Qm_info p:nth-child(1) span {
		margin-left: 13px;
		font-size: 10px;
		font-weight: 300;
		line-height: 30px;
		color: rgba(102, 102, 102, 1);
	}

	.Qm_info p:nth-child(1) span:nth-child(1) img {
		border-radius: 100%;
	}

	.Qm_info p:nth-child(1) span:nth-child(1) {
		width: 16px;
		height: 16px;
	}

	.Qm_info p:nth-child(2) {
		width: 100px;
		height: 30px;
		border: 1px solid rgba(0, 124, 207, 1);
		border-radius: 25px;
		text-align: center;
		line-height: 30px;
		color: #007CCF;
	}

	.anwsernum {
		width: 95%;
		color: #333;
		font-weight: bold;
		margin: 20px auto;
	}

	.anwiserList {
		width: 95%;
		margin: 20px auto;
	}

	.anwiserList ul li {
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
		opacity: 1;
		border-radius: 7px;
		margin: 10px 0px;
		display: flex;
	}

	.alL {
		width: 50px;

	}

	.alL img {
		border-radius: 100%;
		margin: 13px;
	}

	.alR {
		flex: 1;

	}

	.alR p {
		margin: 13px;
	}

	.alR p span:nth-child(1) {
		font-size: 15px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
	}

	.alR p span:nth-child(2) {
		margin-left: 13px;
		font-size: 12px;
		color: #666;
	}

	.alR p:nth-child(2) {
		font-size: 14px;
		line-height: 19px;
		color: rgba(51, 51, 51, 1);
	}
</style>



// WEBPACK FOOTER //
// src/components/Quesrionmore_detail.vue